// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBtpv539_w1fJV6-Onk40HN_olNT7D9t5g",
  authDomain: "simple-firebase-authenti-fb5ac.firebaseapp.com",
  projectId: "simple-firebase-authenti-fb5ac",
  storageBucket: "simple-firebase-authenti-fb5ac.appspot.com",
  messagingSenderId: "1087174001020",
  appId: "1:1087174001020:web:100ebf89f6af5bf2a9a4f9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;